<div class="news-authorization-history-container">
  <div class="news-authorization-history-content">
    <div class="news-authorization-history-items" *ngIf="news?.releaseDate">
      <div class="news-authorization-history-icon">
        <mat-icon svgIcon="icon-schedule"></mat-icon>
      </div>
      <div class="flex-items">
        <div class="news-authorization-history-title">Programação:</div>
        <p class="news-authorization-history-date">
          {{ scheduledDate }} às {{ scheduledHour }}
        </p>
      </div>
    </div>
    <div class="news-authorization-history-items" *ngIf="news?.userUpdated">
      <img
        class="news-authorization-history-photo"
        [src]="
          news?.userUpdated?.photo
            ? news?.userUpdated?.photo
            : '../../../../../assets/icons/person_outline_black_24dp.svg'
        "
      />
      <div class="flex-items">
        <div class="news-authorization-history-title">Atualização:</div>
        <p
          class="news-authorization-history-info"
          *ngIf="news?.userUpdated?.name; else noUpdatedInfo"
        >
          {{ news?.userUpdated?.name }} em {{ updatedAtDay }} às
          {{ updatedAtHour }}
        </p>
        <ng-template #noUpdatedInfo
          ><p class="news-authorization-history-info">
            Informação de atualização indisponível.
          </p>
        </ng-template>
      </div>
    </div>
    <div class="news-authorization-history-items">
      <img
        class="news-authorization-history-photo"
        [src]="
          news?.userCreated?.photo
            ? news?.userCreated?.photo
            : '../../../../../assets/icons/person_outline_black_24dp.svg'
        "
      />
      <div class="flex-items">
        <div class="news-authorization-history-title">Criação:</div>
        <p
          class="news-authorization-history-info"
          *ngIf="news?.userCreated?.name; else noCreatedInfo"
        >
          {{ news?.userCreated?.name }} em {{ createdAtDay }} às
          {{ createdAtHour }}
        </p>
        <ng-template #noCreatedInfo
          ><p class="news-authorization-history-info">
            Informação de criação indisponível.
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
